import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


import {Provider} from "react-redux";
import {store} from "./features/store";
import {ReactNotifications} from "react-notifications-component";


ReactDOM.render(
    <Provider store={store}>
        <ReactNotifications/>
        <App/>
        {/*<NotificationContainer/>*/}

    </Provider>
    ,
    document.getElementById('root')
);

